import { create } from 'zustand';
import { ISocketCmd } from '@src/types';

export type TLastEmoji = Omit<ISocketCmd, 'type' | 'broadcast'>;

interface EmojiStore {
  emoji: TLastEmoji | undefined;
  setEmoji: (emoji: TLastEmoji | undefined) => void;
}

export const useEmojiStore = create<EmojiStore>((set) => ({
  emoji: undefined,
  setEmoji: (emoji) => set({ emoji }),
}));
